export default function Courses() {
  return (
    <div className="min-h-screen bg-black text-white">
      <header className="text-center pt-20 pb-12">
        <h1 className="text-9xl font-bold font-modum text-brand">COURSES</h1>
      </header>
      <div className="flex items-center justify-center py-20">
        <p className="text-gray-400 text-xl">Courses coming soon. Stay tuned!</p>
      </div>
    </div>
  );
}
